import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import RedirectAuthorById from "./components/Authors/RedirectAuthorById";
import Cart from "./components/pages/cart";
import JobCategory from "./components/pages/category";
import Checkout from "./components/pages/checkout";
import AddCourse from "./components/pages/course/addCourse";
import CourseDetails from "./components/pages/course/courseDetails";
import RedirectPublicationById from "./components/Publication/RedirectPublicationById";

import CourseGrid from "./components/pages/course/courseGrid";
import CourseLesson from "./components/pages/course/courseLesson";
import CourseList from "./components/pages/course/courseList";



import PDFViewer from "./components/pages/course/courseList/PDFViewer";
import PDFViewerOpenAccess from "./components/pages/course/courseList/PDFViewerOpenAccess";

import ComingSoon from "./components/pages/error/comingSoon";
import Error404 from "./components/pages/error/error404";
import Error500 from "./components/pages/error/error500";
import UnderConstruction from "./components/pages/error/underConstruction";
import Faq from "./components/pages/faq";
import ForgotPassword from "./components/pages/forgotPassword";
import ForgotPasswordChange from "./components/pages/forgotPassword/ForgotPasswordChange.jsx";
import Login from "./components/pages/login";
import OtpVerify from './components/pages/login/OtpVerify.jsx';
import Logout from "./components/pages/logout";
import Notification from "./components/pages/notification";
import PrivacyPolicy from "./components/pages/policy";
import PricingPlan from "./components/pages/pricingPlan";
import PricingPlan2 from "./components/pages/pricingPlan/pricingPlan2";
import Register from "./components/pages/register";
import RegisterOne from "./components/pages/register/register1";
import RegisterTwo from "./components/pages/register/register2";
import RegisterThree from "./components/pages/register/register3";
import RegisterFour from "./components/pages/register/register4";
import RegisterFive from "./components/pages/register/register5";
import Support from "./components/pages/support";
import TermsCondition from "./components/pages/termsCondition";
import Wishlist from "./components/pages/wishlist";
import { Home2 } from "./components/home2";
import NewPassword from "./components/pages/newPassword";
import ValidationEmail from "./components/pages/register/validationEmail.jsx";
import Profile from "./components/profile/index.jsx";
import ProfileSettings from "./components/profile/settings/instructorSettings.jsx";
import ProfileChangePassword from "./components/profile/settings/instructorChangePassword.jsx";
import ProfileSettingsFormat from "./components/profile/settings/userSettings.jsx";
import AdvancedSearch from './components/advancedSearch/index.jsx';
import PublisherApply from "./components/pages/publisherApply/index.jsx";


import AuthorsDashboardProfile from "./components/Authors/dashboardProfile";
import AuthorsContactPerson from "./components/Authors/contactperson";
import AuthorsCustomerRep from "./components/Authors/customerrep";
import AuthorsPublication from "./components/Authors/publication";
import AuthorsPublisher from "./components/Authors/publishers";

import PublisherDashboardProfile from "./components/Publisher/dashboardProfile";
import RedirectPublisherById from "./components/Publisher/RedirectPublisherById";
import PublisherContactPerson from "./components/Publisher/contactperson";
import PublisherCustomerRep from "./components/Publisher/customerrep";
import PublisherPublication from "./components/Publisher/publication";
import PublisherAuthors from "./components/Publisher/authors";
import Journal from "./components/journals/index.jsx";
import JournalList from "./components/pages/journalList/index.jsx";


import Database from "./components/Database/index.jsx";
import DatabaseAtoZ from "./components/Database/DatabaseAtoZ.jsx";
import Kvkk from "./components/pages/static/kvkk.jsx";
import Help from "./components/pages/static/help.jsx";

import Subscription from "./components/profile/subscription/subscription.jsx";
import UserPublication from "./components/profile/publication/user-publication.jsx";

import CreateAuthor from "./components/profile/authors/CreateAuthor.jsx";
import RedirectPDFOpenAccessById from "./components/pages/course/courseList/RedirectPDFOpenAccessById.jsx";
import Contact from "./components/pages/static/contact.jsx";
import About from "./components/pages/static/about.jsx";
import References from "./components/pages/static/references.jsx";
import RedirectPDFProtectedAccessById from "./components/pages/course/courseList/RedirectPdfProtectedAccessById.jsx";
import ParticipationAgreement from "./components/pages/static/ParticipationAgreement.jsx";
import LegacyRedirect from "./components/LegacyRedirect/LegacyRedirect.jsx";

const Approuter = () => {
  return (
    <BrowserRouter basename="">
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<Home2 />} />
        <Route path="/advanced-search" element={<AdvancedSearch />} />
        <Route path="/publisher-apply" element={<PublisherApply />} />

        <Route path="/subscription" element={<Subscription />} />
        <Route path="/user-publication" element={<UserPublication />} />
        {/* Profile */}

        <Route path="/profile" element={<Profile />} />
        <Route path="/profile-settings" element={<ProfileSettings />} />
        <Route path="/profile-change-password" element={<ProfileChangePassword />} />
        <Route path="/profile-settings-format" element={<ProfileSettingsFormat />} />

        {/* Pages */}
        <Route path="/page-notification" element={<Notification />} />
        <Route path="/pricing-plan" element={<PricingPlan />} />
        <Route path="/pricing-plan2" element={<PricingPlan2 />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/add-course" element={<AddCourse />} />
        <Route path="/publication-list" element={<CourseList />} />



        <Route path="/course-grid" element={<CourseGrid />} />
        {/* New SEO URL for publications */}
        <Route path="/publication/:slug" element={<CourseDetails />} />
        {/* Legacy URL -> redirect to SEO URL */}
        <Route path="/publication-details/:id" element={<RedirectPublicationById />} />
        <Route path="/course-lesson" element={<CourseLesson />} />
        <Route path="/come-soon" element={<ComingSoon />} />
        <Route path="/error-404" element={<Error404 />} />
        <Route path="/error-500" element={<Error500 />} />
        <Route path="/under-construction" element={<UnderConstruction />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/support" element={<Support />} />
        <Route path="/job-category" element={<JobCategory />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/new-password" element={<NewPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register1" element={<RegisterOne />} />
        <Route path="/register2" element={<RegisterTwo />} />
        <Route path="/register3" element={<RegisterThree />} />
        <Route path="/register4" element={<RegisterFour />} />
        <Route path="/register5" element={<RegisterFive />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-password-change/:passwordtoken" element={<ForgotPasswordChange />} />
        <Route path="/term-condition" element={<TermsCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/validation-email/:token" element={<ValidationEmail />} />
        <Route path="/validate-email" element={<ValidationEmail />} />



        <Route path="/view-pdf-protectedaccess/:id" element={<RedirectPDFProtectedAccessById />} />
        <Route path="/view/pdf-protected/:slug" element={<PDFViewer />} />

        <Route path="/view/pdf/:slug" element={<PDFViewerOpenAccess />} />
        <Route path="/view-pdf/:id" element={<RedirectPDFOpenAccessById />} />

        {/*Authors*/}
        <Route
          path="/author-create"
          element={<CreateAuthor />}
        />

        {/* YENİ SEO URL */}
        <Route path="/author/:slug" element={<AuthorsDashboardProfile />} />


        {/* ESKİ URL → canonical'a yönlendir */}
        <Route path="/authors-detail/:id" element={<RedirectAuthorById />} />

        <Route
          path="/authors/contactperson/:id"
          element={<AuthorsContactPerson />}
        />
        <Route
          path="/authors/customerrep/:id"
          element={<AuthorsCustomerRep />}
        />
        <Route
          path="/authors/publications/:id"
          element={<AuthorsPublication />}
        />
        <Route
          path="/authors/publishers/:id"
          element={<AuthorsPublisher />}
        />

        {/*Authors*/}

        {/*Authors*/}
        {/* Yeni SEO URL for publisher */}
        <Route path="/publisher/:slug" element={<PublisherDashboardProfile />} />
        {/* Eski URL -> canonical yönlendir */}
        <Route path="/publisher-detail/:id" element={<RedirectPublisherById />} />
        <Route
          path="/publisher/contactperson/:id"
          element={<PublisherContactPerson />}
        />
        <Route
          path="/publisher/customerrep/:id"
          element={<PublisherCustomerRep />}
        />
        <Route
          path="/publisher/publications/:id"
          element={<PublisherPublication />}
        />
        <Route
          path="/publisher/authors/:id"
          element={<PublisherAuthors />}
        />

        {/*Authors*/}

        <Route
          path="/database/:id"
          element={<DatabaseAtoZ />}
        />

        <Route
          path="/journal-list/:id"
          element={<JournalList />}
        />

        <Route
          path="/journal-detail/:id"
          element={<Journal />}
        />

        <Route
          path="/kvkk"
          element={<Kvkk />}
        />
        <Route
          path="/help"
          element={<Help />}
        />
        <Route>

        </Route>
        <Route path="/otp-verify" element={<OtpVerify />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/references" element={<References />} />
        <Route path="/participation-agreement" element={<ParticipationAgreement />} />
        <Route path="/IdealOnline/lookAtPublicationsConvert/*" element={<LegacyRedirect />} />
        <Route path="/IdealOnline/lookAtPublications/*" element={<LegacyRedirect />} />


        {/* Catch all other /IdealOnline/* routes and redirect to home */}
        {/* <Route path="/IdealOnline/*" element={<Navigate to="/home" />} /> */}

      </Routes>
    </BrowserRouter>
  );
};

export default Approuter;
